import { Person, Sex } from '../types/form';

export function getFirstName(person: Person): string {
  return person.sex === Sex.FEMALE ? 'Janina' : 'Jan';
}

export function getLastName(person: Person): string {
  return person.sex === Sex.FEMALE ? 'Kowalska' : 'Kowalski';
}
